import React from 'react';
import I18n from 'i18n-js';
import gql from 'graphql-tag';
import {
  CheckoutOrderShippingSelectorFields,
  core_apimessages_ShippingMethod,
} from '../schemas/rql';

import FormGroupWithSelect, { ISelectOption } from '@reverbdotcom/commons/src/components/form_group_with_select';

interface Props {
  order: CheckoutOrderShippingSelectorFields.Orders;
  onShippingMethodSelect(order: { listingId: string, shippingMethodType: core_apimessages_ShippingMethod }): void;
  disabled?: boolean;
}

export default function CheckoutOrderShippingSelector(props: Props) {
  const options = buildOptions(props.order);
  const isOnlyOneShippingMethodAvailable = props.order.availableShippingMethods.length < 2;
  const disabled = props.disabled || isOnlyOneShippingMethodAvailable;

  function onShippingMethodSelect(field: { shippingMethodType: core_apimessages_ShippingMethod }) {
    props.onShippingMethodSelect({
      listingId: props.order.listingId,
      shippingMethodType: field.shippingMethodType,
    });
  }

  return (
    <div className="checkout-order-shipping-selector">
      <FormGroupWithSelect
        label={I18n.t('discovery.checkout.orderShippingMethodSelector.label')}
        inputName="shippingMethodType"
        updateField={onShippingMethodSelect}
        options={options}
        disabled={disabled}
        value={props.order.shippingMethod.type}
      />
    </div>
  );
}

function buildOptions(order: CheckoutOrderShippingSelectorFields.Orders): ISelectOption[] {
  return order.availableShippingMethods.map((shippingMethod) => ({
    value: shippingMethod.type,
    text: shippingMethod.name,
  }));
}

export const CheckoutOrderShippingSelectorFragment = gql`
  fragment CheckoutOrderShippingSelectorFields on Checkout {
    _id
    orders {
      listingId
      availableShippingMethods {
        name
        type
      }
      shippingMethod {
        name
        type
      }
    }
  }
`;
